<template>
  <v-container>
    <v-row dense>
     <!--   <v-col cols="12" class="d-flex justify-center">
        <div class="text-h4 font-weight-bold">Mis Parcelas</div>
      </v-col> -->
      <v-col cols="12" class="d-flex justify-center">
        <div class="text-h4 font-weight-bold">Mis Lugares</div>
      </v-col>
      <v-col cols="12">
        <div class="text-h7">Presiona el botón para agregar un nombre de parcela, hato, galera, estanque o apiario</div>
      </v-col>
      <v-col v-if="user_can.add" cols="12">
        <v-btn router to="/ru/parcela" depressed class="primary">
          <v-icon left>mdi-plus</v-icon>
          Agrega Lugar 
        </v-btn>
      </v-col>
      <v-col cols="12" class="tt">
        <div class="text-h6">Ver mis lugares donde produzco</div>
        <div class="text-h8">Presione el nombre del lugar para ver detalles</div>
      </v-col>
      <!-- Mensaje si no hay fincas  -->
      <v-col v-if="Object.keys(registros).length === 0" cols="12" class="mt-8">
        <div class="text-body-1 text-center font-italic">
          Aun no tienes ningún potrero o lugar donde produces 
        </div>
      </v-col>
      <!-- listado de parcelas en el almacenamiento local -->
      <v-col cols="12" class="lista">
        <v-list two-line>
          <template v-for="registro in registros">
            <form-card
              :key="registro.id"
              :top-text="`${registro.nombre || '(sin nombre)'}`"
              :middle-text="`Finca: ${getNombreDeFinca(
                registro.id_finca
              )} , RUC: ${getRucDeFinca(registro.id_finca)}`"
              :bottom-right-text="producerDescription(registro.productor)"
              :sincronized="registro.sincronizado"
              @click="traerRegistroYNavegar(registro)"
            />
          </template>
        </v-list>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { producerDescription } from '@/utilidades'

export default {
  name: 'Parcelas',
  computed: {
    ...mapState('registros', {
      registros: 'parcelas',
      fincas: 'fincas',
    }),
    ...mapGetters('registros', ['getNombreDeFinca', 'getRucDeFinca']),
    user_can() {
      return this.$store.getters['auth/userCan'](this.$route.path)
    },
  },
 /*  mounted() {
    this.$store.commit('ui/updateToolbar', 'Parcelas')
  }, */
  methods: {
    producerDescription,
    async traerRegistroYNavegar(registro) {
      if (registro.sincronizado === true) {
        await this.$store.dispatch('registros/getParcela', { id: registro.id })
      }
      this.$router.push(`/ru/parcela/${registro.id}`)
    },
  },
}
</script>
<style>
  .tt {
    margin-top: 40px;
    margin-bottom: -20px;
  }
  .lista {
    margin-top: 20px;
  }
</style>
